class NewsFilter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (window.wetheme && window.wetheme.webcomponentRegistry) {
      window.wetheme.webcomponentRegistry.register({ key: 'news-filter' });
    }

    this.sectionId = this.dataset.sectionId;
    this.section = this.closest('[data-wetheme-section-type="news-with-filter"]');

    if (!this.section) return;

    // Get elements
    this.categoryButtons = this.querySelectorAll('[data-news-category]');
    this.itemsContainer = this.section.querySelector('[data-news-items-container]');
    this.newsItems = this.section.querySelectorAll('[data-news-item]');
    this.noResultsMessage = this.section.querySelector('[data-news-no-results]');

    // Current state
    this.currentCategory = 'all';

    // Bind events
    this.bindEvents();
  }

  bindEvents() {
    // Category button clicks
    this.categoryButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleCategoryClick(button);
      });

      // Keyboard support
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleCategoryClick(button);
        }
      });
    });
  }

  handleCategoryClick(clickedButton) {
    const category = clickedButton.dataset.newsCategory;

    // Update active state on buttons
    this.categoryButtons.forEach(btn => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    clickedButton.classList.add('is-active');
    clickedButton.setAttribute('aria-pressed', 'true');

    // Update current category and filter
    this.currentCategory = category;
    this.filterItems();
  }

  filterItems() {
    let visibleCount = 0;

    this.newsItems.forEach(item => {
      const itemTags = (item.dataset.newsItemTags || '').toLowerCase().split(',').filter(t => t.trim());

      // Check category match
      const categoryMatch = this.currentCategory === 'all' || itemTags.includes(this.currentCategory.toLowerCase());

      if (categoryMatch) {
        item.classList.remove('news-filter__item--hidden');
        item.style.display = '';
        visibleCount++;
      } else {
        item.classList.add('news-filter__item--hidden');
        // Use setTimeout to allow transition to complete before hiding
        setTimeout(() => {
          if (item.classList.contains('news-filter__item--hidden')) {
            item.style.display = 'none';
          }
        }, 250);
      }
    });

    // Show/hide no results message
    if (this.noResultsMessage) {
      if (visibleCount === 0) {
        this.noResultsMessage.classList.remove('hidden');
      } else {
        this.noResultsMessage.classList.add('hidden');
      }
    }
  }
}

// Only define the custom element if it doesn't already exist
if (!customElements.get('news-filter')) {
  customElements.define('news-filter', NewsFilter);
}
